import { CSSObject } from "@emotion/react";
import {
  constants,
  cssVariableStyles,
  mediaQueryStyles,
} from "@newsela/angelou";

const greyDark = constants.colors.ui.neutral[700];
const greyLight = constants.colors.ui.neutral[300];
const white = constants.colors.ui.white[700];

const { generateIconColorCss } = cssVariableStyles;
const whiteIcon = generateIconColorCss({ primaryColor: white });

const { mediaQuery } = mediaQueryStyles;
const {
  BreakpointNames: { sm },
} = constants.breakpoints;

export const containerCss: CSSObject = {
  position: "relative",
  display: "grid",
  gridColumn: "1 / -1",
  gridRow: 3,
  gap: "1rem",
};

export const homepageArticlesListCss: CSSObject = {
  display: "flex",
  gap: "1rem",
  overflowX: "auto",
  overflowY: "hidden",

  "&::-webkit-scrollbar": {
    display: "none",
  },
  "-ms-overflow-style": "none",
  "scrollbar-width": "none",

  "& > article:last-child": {
    marginRight: "1.5rem",
  },

  "& > article": {
    flex: "0 0 auto",
    minWidth: "248px",
    width: "248px",

    [mediaQuery.upTo(sm)]: {
      minWidth: "200px",
      width: "200px",
    },
  },
};

const arrowButtonCss: CSSObject = {
  position: "absolute",
  zIndex: 12,
  top: "50%",
  transform: "translateY(-50%)",
  backgroundColor: greyDark,
  border: "none",
  cursor: "pointer",
  width: "40px",
  height: "40px",
  borderRadius: "50%",

  "&:hover": {
    background: greyDark,

    "&::after": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: white,
      opacity: 0.08,
      borderRadius: "50%",
    },
  },

  "&:focus": {
    border: `1px solid ${greyLight}`,
  },
};

export const leftArrow: CSSObject = {
  left: "-10px",
  ...arrowButtonCss,
};

export const rightArrow: CSSObject = {
  right: "-10px",
  ...arrowButtonCss,
};

export const iconCss = [
  {
    marginTop: "2px",
    width: "1.25rem",
  },
  whiteIcon,
];
